import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import { SectionHowItWorks } from '../../components';
import css from './HowItWorksPage.module.css';
import image from './background-1440.jpg';

const HowItWorksPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  const ownersSteps = [
    'Create an Account: To start listing your tools and equipment for rent on Lenddit, create an account by clicking on the "Sign Up" button and following the prompts.',
    'List your Tools and Equipment: List your equipment for rent on Lenddit by clicking on the "Add your Tool" button and filling out the required information, including rental fees, availability, and a description of the tool.',
    'Wait for Renters to Book: Once your equipment is listed, interested renters can request to rent it. Review rental requests promptly, and approve or deny based on availability.',
    'Arrange Equipment Exchange: Coordinate with the renter to arrange pickup or delivery of the equipment, either in person or through a third-party delivery service.',
    'Collect the Rental Fee: Lenddit collects the rental fee securely using Lenddit\'s payment processing partner, Stripe, which offers a safe and reliable way to accept credit card payments online.',
    'Monitor the Rental: Check in periodically with the renter during the rental period to ensure proper use and avoid damage.',
    'Collect the Equipment: Arrange to collect the equipment from the renter at the end of the rental period, inspecting it for any damage.',
    'Leave a Review: After the rental period ends, leave a review of the renter on Lenddit\'s website, and build credibility with potential renters.'
  ];

  const rentersSteps = [
    'Create an Account: To start renting tools and equipment on Lenddit, create an account by clicking on the "Sign Up" button and following the prompts.',
    'Browse the Tools and Equipment: Browse the selection of tools and equipment available for rent on Lenddit by using relevant search terms and filters, such as location, availability, and tool type.',
    'Rent the Equipment: Once you\'ve found the equipment you need, fill out the rental request form, including the dates you need the tool, add the equipment to your cart, and pay for your equipment in your cart.',
    'Pay the Rental Fee: Pay the rental fee securely using Lenddit\'s payment processing partner, Stripe, which offers a safe and reliable way to accept credit card payments online.',
    'Pickup or Delivery: Coordinate with the owner to arrange the exchange of the equipment.',
    'Use the Equipment Safely: Use the equipment safely and responsibly, following all instructions and safety information provided by the owner or found in the manual that should be online.',
    'Return the Equipment: Return the equipment to the owner at the end of the rental period, in the same condition it was rented (Clean equipment prior to return).',
    'Leave a Review: After the rental period ends, leave a review of the owner on Lenddit\'s website to help future renters make informed decisions.'
  ];

  // prettier-ignore
  return (
    <StaticPage
      title="About Us"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'HowItWorksPage',
        description: 'How it works',
        name: 'How it works',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain>
          <div className={css.introSection}>
            <h1 className={css.pageTitle}>How Lenddit works</h1>
            <h2 className={css.pageSubtitle}>We answer common questions for Lenddit's Owners and Renters.</h2>
          </div>

          <div className={css.staticPageWrapper}>

            <img src={image} className={css.coverImage} />

            <h2>For Owners</h2>
            {ownersSteps.map((step, index) => (
              <details key={index}>
                <summary>{index + 1}. {step.split(":")[0]}</summary>
                <p>{step.split(":")[1]}</p>
              </details>
            ))}

            <h2>For Renters</h2>
            {rentersSteps.map((step, index) => (
              <details key={index}>
                <summary>{index + 1}. {step.split(":")[0]}</summary>
                <p>{step.split(":")[1]}</p>
              </details>
            ))}


          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default HowItWorksPage;
